import script from "./config-detail.vue?vue&type=script&setup=true&lang=tsx"
export * from "./config-detail.vue?vue&type=script&setup=true&lang=tsx"

import "./config-detail.vue?vue&type=style&index=0&id=cba6b2c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cba6b2c0"]])

export default __exports__